/* import __COLOCATED_TEMPLATE__ from './ticket-attributes-tab-body.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const TicketAttributesTabBody = templateOnlyComponent<Signature>();
export default TicketAttributesTabBody;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::TicketAttributesTabBody': typeof TicketAttributesTabBody;
    'inbox2/ticket-attributes-tab-body': typeof TicketAttributesTabBody;
  }
}
